<template>
    <div class="jh-dialog-wrap">
        <div class="jh-dialog-header">
            <h1>금칙어 상세정보</h1>
            <div class="is-right">
                <v-btn class="jh-btn is-icon" title="닫기" @click="$emit('hide')"><i class="jh-icon-close-lg is-white"></i></v-btn>
            </div>
        </div>
        <div class="jh-dialog-body">            
            <v-form ref="form" v-model="isFormValid" lazy-validation>
                <table class="jh-tbl-detail">
                    <colgroup>
                        <col width="100px">
                        <col>
                    </colgroup>
                    <tbody>
                        <tr>
                            <th><label>금칙어코드</label></th>
                            <td>
                                <v-text-field class="jh-form is-md is-trns" name="GROUP_CD" v-model="formWordData.PROH_CODE" maxlength="100" outlined required readonly></v-text-field>
                            </td>
                        </tr>
                        <tr>
                            <th><label class="is-required">금칙어</label></th>
                            <td>
                                <v-text-field class="jh-form is-md" name="PROH_WORD" v-model="formWordData.PROH_WORD" :rules="[formRules.newWord.required]" maxlength="100" outlined required></v-text-field>
                            </td>
                        </tr>
                        <tr>
                            <th><label class="is-required">변환어</label></th>
                            <td>
                                <v-text-field class="jh-form is-md" name="CHANGE_WORD" v-model="formWordData.CHANGE_WORD" :rules="[formRules.chWord.required]" maxlength="100" outlined required></v-text-field>
                            </td>
                        </tr>
                        <tr>
                            <th><label>등록자명</label></th>
                            <td>
                                <v-text-field class="jh-form is-md is-trns" name="REG_NM" v-model="formWordData.REG_NM" maxlength="100" outlined required readonly></v-text-field>
                            </td>
                        </tr>
                        <tr>
                            <th><label>등록일자</label></th>
                            <td>
                                <v-text-field class="jh-form is-md is-trns" name="REG_DTTM" v-model="formWordData.REG_DTTM" maxlength="100" outlined required readonly></v-text-field>
                            </td>
                        </tr>
                        <tr>
                            <th><label class="is-required">사용여부</label></th>
                            <td>
                                <v-select  
                                    class="jh-form is-md"
                                    :items="useYnDrop" 
                                    name="USE_YN"
                                    v-model="formWordData.NEW_USE_YN"
                                    :rules="[formRules.useYn.required]"
                                    outlined required
                                ></v-select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </v-form>
        </div>
        <div class="jh-dialog-footer" v-if="this.mixin_set_btn(this.$options.name, 'btnSave')">
            <v-btn class="jh-btn is-md is-main" @click="submit">저장</v-btn>
        </div>
    </div>
</template>

<script>
import api from "../../store/apiUtil";
import { mixin } from "@/mixin/mixin.js";
import { mapGetters } from "vuex";

let jsonObj

export default {
  name: "MENU_E020603P02", //name은 'MENU_' + 파일명 조합
  mixins:[mixin],
  props: {
    param: {
      type: Object,
    },
    searchCustKey: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      useYnDrop: [],
      common_code: [],
      formWordData: {},
      isFormValid: true,
      formRulesSubfix: ' 은(는) 필수입력입니다.',
      formRules: {
        newWord: {
          required: v => !!v || '금칙어' + this.formRulesSubfix
        },
        chWord: {
          required: v => !!(v  && (v+'').trim()!=='') || '변환어' + this.formRulesSubfix
        },
        useYn: {
          required: v => !!(v  && (v+'').trim()!=='') || '사용여부' + this.formRulesSubfix
        }
      },
    }
  },
  mounted() {
    this.initData()
  },
  methods:{
    async initData(){
      if(this.isEmpty(this.searchCustKey)){
        this.common_alert('회사구분 코드가 존재하지 않습니다.', 'error')
        this.$emit('hideAndGetList');
      }
      this.$refs.form.resetValidation()
      this.formWordData=JSON.parse((JSON.stringify(this.param)))
      let codeName = ["TWB001"];
      this.common_code= await this.mixin_common_code_get_all(codeName);
      this.useYnDrop = await this.mixin_common_code_get(this.common_code, 'TWB001', '전체')
      this.formWordData.NEW_USE_YN = this.formWordData.USE_YN

    },
    async submit(){

      if(!this.$refs.form.validate()) return false

      let URLData = "/api/chat/setting/banned-word/modify";
      let HEADER_SERVICE = "chat.setting.banned-word";
      let HEADER_METHOD = "modify";
      let HEADER_TYPE = "BIZ_SERVICE";



      let jsonData = {
        MODIFY_PROH_CODE: this.formWordData.PROH_CODE,
        MODIFY_PROH_WORD: this.formWordData.PROH_WORD,
        MODIFY_CHANGE_WORD: this.formWordData.CHANGE_WORD,
        USE_YN: this.formWordData.NEW_USE_YN,
        USER_NM: this.userId,
        USER_ID: this.userId,
        USER_DEPT_CD: 'x',
        ASP_NEWCUST_KEY: this.searchCustKey
      };

      //api 호출 부분
      await api
          .post(URLData, jsonData, {
            head: {
              SERVICE: HEADER_SERVICE,
              METHOD: HEADER_METHOD,
              TYPE: HEADER_TYPE
            },
          })
          .then((response) => {
            if(!this.isEmpty(response) && !response.data.HEADER.ERROR_FLAG) {
              this.common_alert('정상처리 되었습니다.', 'done')
              this.$emit('hideAndGetList');
            } else {
              this.common_alert(response.data.HEADER.ERROR_MSG, 'error')
            }
          })
          .catch((err) => {
            alert(err);
          });
    },
    isEmpty(val) {
      if (val == null) return true
      if (typeof val === 'undefined') return true
      if (typeof val === 'string' && val === '' && (''+val) === '') return true
      if (Array.isArray(val) && val.length < 1) return true
      if (typeof val === 'object' && val.constructor.name === 'Object' && Object.keys(val).length < 1 && Object.getOwnPropertyNames(val) < 1) return true
      if (typeof val === 'object' && val.constructor.name === 'String' && Object.keys(val).length < 1) return true
    },
  },
  computed: {
    ...mapGetters({
      userId: 'userStore/GE_USER_ID',
      userNm: 'userStore/GE_USER_MENU'
    }),
  },
};
</script>

<style></style>
